import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { templateData } from '../data/templateData';
import './checkin.css';
import { useAuth } from '../hooks/useAuth';
// import ProfessionalChatbot from '../components/ProfessionalChatbot';
import Alert from "../components/Alert";
import PhoneInput from "../components/PhoneInput"

const PatientMonitoringCheckIn = () => {
  const { id } = useParams();
  const [adhoc, setAdhoc] = useState(false);
  const [template, setTemplate] = useState(null);

  const [sys_prompt, setSysPrompt] = useState("");
  const [msg, setMsg] = useState("");
  const [surgeryType, setSurgeryType] = useState("");
  const [anesthesiaType, setAnesthesiaType] = useState("");
  const isFormValid = surgeryType.trim() !== "" && anesthesiaType.trim() !== "";
  const [patientHistory, setPatientHistoryType] = useState("");

  const [loading, setLoading] = useState(true);
  const [promptLoading, setPromptLoading] = useState(false); // 新增：仅用于加载 DB prompt 的轻量状态
  const [error, setError] = useState(null);
  const { user, logout } = useAuth();
  const API_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
  const [showAlert, setShowAlert] = useState(false);

  const [alertMessage, setAlertMessage] = useState("");

  const triggerAlert = (msg) => {
      setAlertMessage(msg);
      setShowAlert(true);
    };

  const PROMPT = `task: "Appointment Reminder"
category: "Appointment Reminder"
appointment_date: "<APPOINTMENT_DATE>"
appointment_time: "<APPOINTMENT_TIME>"
location: "<LOCATION>"
instructions:
- "Confirm the patient's name at the start of the call."
- "Remind them of their appointment on <APPOINTMENT_DATE> at <APPOINTMENT_TIME>."
- "Inform them the appointment is at <LOCATION>."
- "Ask if they have any questions or need to reschedule. If they need to reschedule, they can do so on the HealthHub app."`;

  useEffect(() => {
    // 初始化：根据路由 id 选择模板
    const init = async () => {
      try {
        setAdhoc(id === "Adhoc Task");

        const foundtemplate = templateData.find(t => t.service === id);
        if (!foundtemplate) {
          setError('assistant not found');
          setLoading(false);
          return;
        }

        setTemplate(foundtemplate);
        setLoading(false);

        // 仅针对这两个功能（或更通用：存在 promptId 时）从后端拉取 MongoDB prompt
        if (foundtemplate.promptId) {
          setPromptLoading(true);
          try {
            const res = await fetch(
              `${API_URL}/api/function_prompt/${encodeURIComponent(foundtemplate.promptId)}`,
              { headers: { "Authorization": "Bearer " + user.token } }
            );
            if (!res.ok) {
              throw new Error(`Prompt not found: ${foundtemplate.promptId}`);
            }
            const data = await res.json(); // { prompt_id, prompt }
            // 将从 DB 拿到的 prompt 注入到 template 状态里，后续 handleSubmit 仍用 template.prompt，不改原流程
            //setTemplate(prev => prev ? { ...prev, prompt: data.prompt || "" } : prev);
            setSysPrompt(data.prompt.template)
            setMsg(data.prompt.msg)
          } catch (e) {
            // 拉取失败时不打断页面，其它功能照常；仅提示错误
            console.error(e);
            setError(e.message);
          } finally {
            setPromptLoading(false);
          }
        }
      } catch (e) {
        console.error(e);
        setError('init failed');
        setLoading(false);
      }
    };

    init();
  }, [id, API_URL, user?.token]);

  if (loading) {
    return <div>Loading details...</div>;
  }

  const makePromptPrefix = () => {
    const parts = [
      `Type of Surgery: ${surgeryType.trim()}`,
      `Type of Anesthesia: ${anesthesiaType.trim()}`
    ];
    const hist = (patientHistory || "").trim();
    if (hist) parts.push(`Patient History: ${hist}`);
    return parts.join("\n");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const prefix = makePromptPrefix();
    const finalSysPrompt = `${prefix}\n\n${(sys_prompt || "").trim()}`.trim();

    const newTask = {
      "type":  "sms", // 按你的要求：不改动原来的逻辑
      "name": e.target.name.value,
      "phone_number": e.target.phone_code.value+e.target.phone.value, 
      "lang": e.target.lang.value,
      "message": e.target.message.value, // 此处若为 Pre-screening/Preliminary，将是 DB 返回的 prompt
      "sys_prompt": finalSysPrompt,
      "prompt_id": template.promptId
    }
    if (e.target.time.value){
      newTask["call_at"] = e.target.time.value
    }

    try {
      const response = await fetch(API_URL+'/api/createjob',
        {
          method: "POST",
          headers: { "Content-Type": "application/json","Authorization": "Bearer "+user.token },
          body: JSON.stringify(newTask)
        }
      );

      if (response.ok) {
        triggerAlert("Successfully send request!");
      } else {
        throw new Error('Something went wrong');
      }

    } catch (error) {
      console.log('There was an error');
      triggerAlert("There was an error");
    }
  }

  return (
    <div className="container">
      {/* Header
      <div className="header-1">
        <button className="back-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Roles
        </button>
      </div>
      */}
      {/* Main Content */}
      <div className="main-content-1">
        {/* Left Column - Profile */}
        <div className="profile-column">
          <div className="profile-image-container">
            <img
              src={template.photo}
              alt="Healthcare professional"
              className="profile-image"
            />

          </div>

          <div className="profile-info">
            <h2 className="profile-name">{template.name}</h2>
            <h3 className="profile-role">{template.service}</h3>
            <p className="profile-description">
               {template.introduction}
            </p>
          </div>
        </div>

        {/* Right Column - Details */}
        <div className="details-column">
          <h1 className="page-title">Patient Contact Information</h1>

          <form onSubmit={handleSubmit}>
            {/* Action Buttons */}
            <div className="action-buttons">
              <div className="action-button">
                <div className="action-icon phone-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                {/* <input
                  type="text"
                  id="phone"
                  name="phone"
                  placeholder="+65 phone number"
                  className={`form-control`}
                /> */}
                <PhoneInput/>
              </div>

              <div className="action-button">
                <div className="action-icon settings-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"  viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                  </svg>
                </div>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="patient name"
                  className={`form-control`}
                />
              </div>

              <div className="action-button">
                <div className="action-icon settings-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <input
                  type="datetime-local"
                  id="time"
                  name="time"
                  placeholder=""
                  style={{width:"50%"}}
                  className={`form-control`}
                />
              </div>

              <div className="action-button">
                <div className="action-icon settings-icon">
                  <svg fill="currentColor" width="32" height="32" stroke="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title>ionicons-v5-l</title><path d="M478.33,433.6l-90-218a22,22,0,0,0-40.67,0l-90,218a22,22,0,1,0,40.67,16.79L316.66,406H419.33l18.33,44.39A22,22,0,0,0,458,464a22,22,0,0,0,20.32-30.4ZM334.83,362,368,281.65,401.17,362Z"/><path d="M267.84,342.92a22,22,0,0,0-4.89-30.7c-.2-.15-15-11.13-36.49-34.73,39.65-53.68,62.11-114.75,71.27-143.49H330a22,22,0,0,0,0-44H214V70a22,22,0,0,0-44,0V90H54a22,22,0,0,0,0,44H251.25c-9.52,26.95-27.05,69.5-53.79,108.36-31.41-41.68-43.08-68.65-43.17-68.87a22,22,0,0,0-40.58,17c.58,1.38,14.55,34.23,52.86,83.93.92,1.19,1.83,2.35,2.74,3.51-39.24,44.35-77.74,71.86-93.85,80.74a22,22,0,1,0,21.07,38.63c2.16-1.18,48.6-26.89,101.63-85.59,22.52,24.08,38,35.44,38.93,36.1a22,22,0,0,0,30.75-4.9Z"/></svg>
                </div>
                <select
                  id="lang"
                  name="lang"
                  className="template-select"
                >
                  <option value="">Experiment Selection</option>
                  <option value="Anaesthesia">Anaesthesia</option>
                  <option value="Emergency Department">Emergency Department</option>
                  
                </select>
              </div>

              { adhoc === true &&
                <div className="agenda-section">
                  <h2 className="section-title">Checklist</h2>
                  <textarea
                    type="text"
                    cols="40"
                    rows="10"
                    id="checklist"
                    name="checklist"
                    className="form-control"
                    defaultValue={PROMPT}
                  />
                  {/* <ProfessionalChatbot/> */}
                </div>
              }

            </div>
          

          {/* Agenda Section */}
          <div className="agenda-section">
            <h2 className="section-title">Agenda</h2>
            <div className="agenda-container">
              <h3 className="agenda-title">{template.agenda ? template.agenda["title"]: ""}</h3>
              <div className="form-group" style={{ marginBottom: 12 }}>
                <h3 className="checklist-title">Type of Surgery</h3>
                <input
                  id="typeOfSurgery"
                  name="typeOfSurgery"
                  type="text"
                  className="form-control"
                  placeholder="e.g. Laparoscopic cholecystectomy"
                  value={surgeryType}
                  onChange={(e) => setSurgeryType(e.target.value)}
                />
              </div>
              
              <div className="form-group" style={{ marginBottom: 16 }}>
                <h3 className="checklist-title">Type of Anesthesia</h3>
                <select
                  id="typeOfAnesthesia"
                  name="typeOfAnesthesia"
                  className="form-control"
                  value={anesthesiaType}
                  onChange={(e) => setAnesthesiaType(e.target.value)}
                >
                  <option value="" disabled>
                    Select anesthesia type
                  </option>
                  <option value="General anesthesia">General anesthesia</option>
                  <option value="Regional anesthesia">Regional anesthesia</option>
                  <option value="Epidural">Epidural</option>
                  <option value="Spinal anesthesia">Spinal anesthesia</option>
                  <option value="Monitored sedation care (MAC)">Monitored sedation care (MAC)</option>
                </select>
              </div>

              <div className="form-group" style={{ marginBottom: 12 }}>
                <h3 className="checklist-title">Patient History</h3>
                <textarea
                  id="patientHistory"
                  name="patientHistory"
                  type="text"
                  className="form-control"
                  rows="2" cols="80"
                  placeholder="Enter Patient's History"
                  value={patientHistory}
                  onChange={(e) => setPatientHistoryType(e.target.value)}
                />
              </div>

              <p className="agenda-description">
                {template.agenda ? template.agenda["descipt"]: ""}
              </p>
              { adhoc === false && template.agenda && template.agenda.checklist && (
                <div>
                <div>
                  <h3 className="checklist-title">SMS Message</h3>
                  <textarea type="text" className="form-control" id="message" name="message" rows="6" cols="80" value={msg} onChange={(e) => setMsg(e.target.value)}></textarea>

                  
                </div>
                <div>
                  <h3 className="checklist-title">System Prompt</h3>
                  <textarea type="text" className="form-control" id="sys_prompt" name="sys_prompt" rows="12" cols="80" value={sys_prompt} onChange={(e) => setSysPrompt(e.target.value)}></textarea>

                  
                </div>


                </div>
              )}
            </div>

          </div>

          <div>
            <span
              className={`tooltip-wrapper ${!isFormValid ? "has-tooltip" : ""}`}
              data-tooltip="Please fill in the type of surgery and anesthesia below."
              // keep accessibility even when disabled
              aria-label={!isFormValid ? "Please fill in the type of surgery and anesthesia below." : undefined}
            >
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!surgeryType || !anesthesiaType} // 若 DB prompt 还在加载中，可防止空 prompt 提交
            >
              Create Task
            </button>
            </span>
          </div>

          </form>
        </div>
      </div>

      <Alert
        show={showAlert}
        onClose={() => setShowAlert(false)}
        message={alertMessage}
      />
    </div>
  );
};

export default PatientMonitoringCheckIn;
